/* eslint-disable */
import * as brandful from 'telia-front-react';

/**
 * To keep component names readable in logger output
 */
for (const Component of Object.values(brandful)) {
}
